import { isProdEnvironment } from '@/utils/environment';

const GTM_CONTAINER_ID = 'GTM-NKK98SG';
const GTM_SCRIPT_ID = 'gtm-container';

// GTM tags hash values with CryptoJS, which is not bundled with the app. These
// must execute before gtm.js, so they are inserted with async = false to keep
// dynamically added scripts in document order.
const GTM_DEPENDENCY_SCRIPTS = [
  'https://cdnjs.cloudflare.com/ajax/libs/crypto-js/3.3.0/rollups/hmac-sha256.js',
  'https://cdnjs.cloudflare.com/ajax/libs/crypto-js/3.3.0/components/enc-base64-min.js',
];

let injected = false;

/**
 * Loads Google Tag Manager, in production only.
 *
 * Call once from the app entry point. `useGtmDataLayerPush` already checks for
 * `window.dataLayer` before pushing, so events are silently dropped elsewhere.
 */
export const injectGtm = (): void => {
  if (injected || !isProdEnvironment()) return;
  if (document.getElementById(GTM_SCRIPT_ID)) return;
  injected = true;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  for (const src of GTM_DEPENDENCY_SCRIPTS) {
    const dependency = document.createElement('script');
    dependency.src = src;
    dependency.async = false;
    document.head.appendChild(dependency);
  }

  const script = document.createElement('script');
  script.id = GTM_SCRIPT_ID;
  script.async = false;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}`;
  document.head.appendChild(script);
};
